import {
  collection,
  query,
  where,
  getDocs,
  CollectionReference,
  orderBy,
  QueryConstraint,
  limit,
} from 'firebase/firestore'
import leaveRequestServiceConfigs from './configs'
import { db } from '../../firebase/firebase'
import { ApprovalStatus } from '../../database/enums/ApprovalStatus.enum'
import { LeaveRequestSource } from '../../database/enums/LeaveRequestSource.enum'
import { LeaveRequest, LeaveRequestRaw } from '../../database/tables'
import LeaveRequestTableHelper from '../../database/tables/helpers/leave-request.helper'
import constants from '../../constants'

export type GetUnrespondedLeaveRequestsParams = {
  source?: LeaveRequestSource
}

export default async function getUnrespondedLeaveRequests(
  params: GetUnrespondedLeaveRequestsParams,
): Promise<LeaveRequest[]> {
  return new Promise(async (resolve, reject) => {
    try {
      const constraints: QueryConstraint[] = [
        where('approvalStatus', '==', ApprovalStatus.UNRESPONDED),
        orderBy('createdAt', 'desc'),
        limit(constants.limits.fetchDataCount.sm),
      ]

      if (!!params.source) constraints.push(where('source', '==', params.source))

      const currCollection = collection(
        db,
        leaveRequestServiceConfigs.collectionName,
      ) as CollectionReference<LeaveRequestRaw>
      const q = query(currCollection, ...constraints)
      const querySnapshot = await getDocs(q)

      const results: any[] = []
      querySnapshot.forEach(doc => {
        results.push(LeaveRequestTableHelper.fromRaw({ id: doc.id, rawData: doc.data() }))
      })

      return resolve(results)
    } catch (e) {
      return reject(e)
    }
  })
}
